import styled from '@emotion/styled';
import { colors } from '@libs/ui';
import { dateToStr, labelName, useItemNames, useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import { useProcessingMonth } from '../context';

const ProcessingMonthBadge = styled.div`
  display: inline-flex;
  height: 26px;
  margin-top: 7px;
  border: 1px solid ${colors.deepGray};
  border-radius: 4px;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  color: ${colors.txtBlack};
`;

const Label = styled.span`
  width: 60px;
  border-right: 1px solid ${colors.deepGray};
  text-align: center;
  background-color: ${colors.gray};
`;

const Value = styled.span`
  width: 70px;
  font-weight: bold;
  text-align: center;
  background-color: ${colors.gray};
`;

function ProcessingMonthLabel() {
  const getLabelName = useItemNames(labelName);
  const { processingMonth } = useProcessingMonth();
  const { dateFormat } = useLocalizedContents();

  return (
    <ProcessingMonthBadge id="global-processing-month-label">
      <Label>{getLabelName('processingMonth')}</Label>
      <Value>{dateToStr(processingMonth, dateFormat.ym)}</Value>
    </ProcessingMonthBadge>
  );
}

export { ProcessingMonthLabel };
